import JobIcon from '@components/Icon/Job';
import JobOfferDataTable from '@modules/JobOffers/JobOfferDataTable';
import JobOfferGrid from '@modules/JobOffers/JobOfferGrid';
import JobApplicationIcon from '@components/Icon/JobApplication';
import LockIcon from '@components/Icon/Lock';
import LockOpenIcon from '@components/Icon/LockOpen';
import { Box } from '@mui/material';
import { SortModel } from '@components/DataTable/types';

interface JobOfferListProps {
    viewMode: 'grid' | 'list';
    isLoadingMore?: boolean;
    onLoadMore?: () => void;
    data: {
        _id: string;
        imageUrl: string;
        slug: string;
        fullName: string;
        jobOffer: string;
        pro?: {
            _id: string;
            commercialName?: string;
            city?: string;
            brandLogo?: {
                url: string
            };
        };
        brand?: {
            brandLogo?: {
                url: string
            };
        };
        city: string;
        rating: number;
        origin: string;
        totalApplied: number;
        appliedJobs: number;
        experience: string;
        contractType: string;
        education: string;
        company: string;
        logo: string;
        title: string;
        active: boolean;
    }[];
    onConfirm: (params: { title: string; description: string }) => void;
    loading: boolean;
    setSelectedId: (id: string) => void;
    currentPage: number;
    pageSize: number;
    totalRows: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    sortModel?: SortModel[];
    onSortModelChange?: (model: SortModel[]) => void;
}

const JobOfferList = ({
    viewMode,
    data,
    onConfirm,
    loading,
    isLoadingMore,
    onLoadMore,
    setSelectedId,
    currentPage,
    pageSize,
    totalRows,
    onPageChange,
    onPageSizeChange,
    sortModel,
    onSortModelChange,
}: JobOfferListProps) => {

    const cardMenuList = [
        {
            id: 1,
            path: '/',
            title: 'Job Offer Detail',
            style: 'white',
            type: 'redirect',
            icon: JobIcon,
        },
        {
            id: 1,
            path: '/',
            title: 'Manage Applications',
            style: 'white',
            type: 'redirect',
            icon: JobApplicationIcon,
        },
        {
            id: 3,
            path: '/',
            title: 'Deactivate  Account',
            style: 'red',
            type: 'action',
            actionTitle: 'Are you sure you want to deactivate this Account?',
            actionDescription:
                'By deactivate this account, Talent  wont be able to access this account anymore. You can redo this action in the future',
            confirmTitle: 'Deactivate',
            cancelTitle: 'Annuler',
            action: 'deactivate',
            icon: LockIcon,
            active: true,
        },
        {
            id: 4,
            path: '/',
            title: 'Reactivate Account',
            style: 'green',
            type: 'action',
            actionTitle: 'Are you sure you want to reactivate this Account?',
            actionDescription: 'By reactivate this account, Talent will be able to access this account again.',
            confirmTitle: 'Activate',
            cancelTitle: 'Annuler',
            action: 'activate',
            icon: LockOpenIcon,
            active: false,
        },
    ];

    return (
        <Box sx={{ overflowX: 'hidden', display: 'flex', flexDirection: 'column', gap: 2, height: '100%', flex: 1 }}>
            {viewMode === 'list' && (
                <JobOfferDataTable
                    data={data}
                    onConfirm={onConfirm}
                    loading={loading}
                    isLoadingMore={isLoadingMore}
                    onScrollEnd={onLoadMore}
                    setSelectedId={setSelectedId}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalRows={totalRows}
                    onPageChange={onPageChange}
                    onPageSizeChange={onPageSizeChange}
                    sortModel={sortModel}
                    onSortModelChange={onSortModelChange}
                />
            )}
            {viewMode === 'grid' && (
                <JobOfferGrid
                    cardMenuList={cardMenuList}
                    data={data}
                    onConfirm={onConfirm}
                    loading={loading}
                    setSelectedId={setSelectedId}
                />
            )}
        </Box>
    );
};

export default JobOfferList;
